import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetInventoriesQuery,
  GetInventoriesQueryVariables,
} from "./GetInventories.generated";

export const GET_INVENTORIES: TypedDocumentNode<
  GetInventoriesQuery,
  GetInventoriesQueryVariables
> = gql`
  query GetInventories {
    user {
      uuid
      inventories {
        inventoryUuid
        createdAt
        updatedAt
        status
      }
    }
  }
`;
